import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, Textarea } from '@hb/coffee';
import { checkCompanyName, checkAddressSensitive, validarorTips } from '@/shared/utils/validator';
import { SupplementInfoField } from '@/components/supplement-info-fields/types';
import { emojFilter } from '../../utils';

@Component({ name: 'CompanyName' })
export default class CompanyName extends Vue implements SupplementInfoField {
  @Prop()
  private value!: string;

  /** 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
  */
  @Prop()
  private validator: ((value: string, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private companyName = '';

  private errorMsg = '';

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  // 单位名称
  public onValidator(): boolean {
    const val = this.companyName;
    if (typeof this.validator === 'function') {
      return this.validator(val, this.setErrorMsg.bind(this));
    }
    if (!checkAddressSensitive(val)) {
      this.errorMsg = validarorTips.addressSensitiveTip;
      return false;
    }
    if (!checkCompanyName(val)) {
      this.errorMsg = '请填写正确的公司名称(不少于5个字)';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private created() {
    if (this.value) {
      this.companyName = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: string) {
    this.companyName = val;
  }

  private onChangeBaseCompany(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onBlur() {
    this.onValidator();
    this.$emit('blur');
  }

  private render() {
    return (
        <Field
          label="公司名称"
          errorMessage={this.errorMsg}
        >
          <Textarea
            v-model={this.companyName}
            placeholder="填写公司全称（不少于5个字）"
            formatter={emojFilter}
            on={{
              'update:modelValue': (val: string) => {
                this.onChangeBaseCompany(val);
              },
            }}
            onBlur={this.onBlur.bind(this)}
          />
        </Field>
    );
  }
}
